import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { MessageBox } from 'syf-component-library/ui/patterns';
export const MessageBoxContainer = styled(MessageBox) `
  padding: ${spacing.large}px ${spacing.base}px;

  @media ${query.greaterThanMedium} {
    padding: ${spacing.large}px;
  }
`;
export const ContentContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
  }
`;
export const EnrolledInCAPTitle = styled.div `
  font-size: 14px;
  font-weight: ${fontWeights.bold};
  text-align: center;
  max-width: 250px;
  margin-top: ${spacing.small}px;
  margin-left: 0;

  @media ${query.greaterThanMedium} {
    text-align: left;
    width: 164px;
    margin-top: 0;
    margin-left: ${spacing.medium}px;
  }
`;
export const PaymentAmountContainer = styled.div `
  text-align: center;
  border-bottom: 1px #34657f solid;
  border-right: 0;
  padding-right: 0;
  padding-bottom: ${spacing.base}px;

  @media ${query.greaterThanMedium} {
    border-bottom: 0;
    border-right: 1px #34657f solid;
    padding-right: ${spacing.large}px;
    padding-bottom: 0;
  }
`;
export const AmountText = styled.div `
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.medium}px;
`;
export const AmountSubtitle = styled.div `
  text-transform: uppercase;
  font-size: 14px;
`;
export const PlanLengthContainer = styled.div `
  text-align: center;
  padding-top: ${spacing.base}px;
  padding-left: 0;

  @media ${query.greaterThanMedium} {
    padding-top: 0;
    padding-left: ${spacing.large}px;
  }
`;
export const EndDateText = styled.div `
  font-size: ${fontSizes.medium}px;
`;
export const PlanLengthText = styled.div `
  text-transform: uppercase;
  font-size: 14px;
`;
export const LeftSideContainer = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: ${spacing.large}px;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
    margin-bottom: 0;
  }
`;
export const RightSideContainer = styled.div `
  display: flex;
  flex-direction: column;

  @media ${query.greaterThanMedium} {
    flex-direction: row;
  }
`;
